import 'bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";

import '../styles/main.scss';

import top_bg from '../assets/imgs/top bg.png'
import bot_bg from '../assets/imgs/bot bg.png'
import logo_img from '../assets/imgs/logo.jpg'
import patrocinio_img from '../assets/imgs/patrocinio.png'
import header_img from '../assets/imgs/header.png'

window.APP_ASSETS = {
    'logo': logo_img,
    'patrocinio': patrocinio_img,
    'header': header_img
};

window.APP_BG_ASSETS = {
    'top-bg': top_bg,
    'bot-bg': bot_bg
};
